import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ToastPayload {
  type: "success" | "error" | "info" | "warning";
  head: string;
  text: string;
}

interface ToastState {
  message: ToastPayload | null;
  /** Bumped on every toast so repeating the same message still re-triggers. */
  nonce: number;
}

const initialState: ToastState = {
  message: null,
  nonce: 0,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<ToastPayload>) => {
      state.message = action.payload;
      state.nonce += 1;
    },
    clearToast: (state) => {
      state.message = null;
    },
  },
});

export const { showToast, clearToast } = toastSlice.actions;
export default toastSlice.reducer;
